@if (offer(); as o) {
	<div class="u-card u-card--float">
		<p class="u-text--grey-blue u-text--medium u-m-bottom--tiny">
			{{ 'BOOKING.STEP' | translate: { currentStep: currentStep(), totalSteps: totalSteps() } }}
		</p>
		<p class="u-title">{{ stepName() | translate }}</p>

		<hr class="u-m-top--md u-m-bottom--md" />

		<p class="u-text--grey-blue u-m-bottom--sm">{{ 'BOOKING.INFO_OPTIONALS' | translate }}</p>

		<tvcore-message color="orange" icon="warning" class="u-m-bottom--md">
			<p class="u-text--bold u-m-bottom--xxs">{{ 'BOOKING.WARNING_TITLE' | translate }}</p>
			<p [innerHTML]="(o.type === OffersType.ACCOMMODATION ? 'BOOKING.WARNING_DESCRIPTION_ACCOMMODATION' : 'BOOKING.WARNING_DESCRIPTION') | translate"></p>
		</tvcore-message>

		@if (o.type === OffersType.ORGANIZED_HOLIDAY) {
			@switch (currentStep()) {
				@case (1) {
					<ivva-booking-first-camp #stepComponent></ivva-booking-first-camp>
				}
				@case (2) {
					<ivva-booking-other-camps #stepComponent></ivva-booking-other-camps>
				}
				@case (3) {
					<ivva-booking-oh-details #stepComponent></ivva-booking-oh-details>
				}
				@case (4) {
					<ivva-booking-oh-contacts #stepComponent></ivva-booking-oh-contacts>
				}
			}
		} @else {
			@switch (currentStep()) {
				@case (1) {
					<ivva-booking-details #stepComponent [type]="o.type" />
				}
				@case (2) {
					<ivva-booking-info #stepComponent [type]="o.type" />
				}
			}
		}

		<hr class="u-m-top--md u-m-bottom--md" />

		<div class="flex-row flex--space flex-gap--xs">
			@if (currentStep() > 1) {
				<button class="c-btn c-btn--secundary" (click)="prev()" type="button" [disabled]="loadingSubmit()">{{ 'BOOKING.PREVIOUS_BUTTON' | translate }}</button>
			} @else {
				<div></div>
			}

			@if (currentStep() === totalSteps()) {
				<button class="c-btn" (click)="submit()" type="submit" [disabled]="loadingSubmit()">
					{{ loadingSubmit() ? 'Bezig met indienen...' : ((o.type === OffersType.ACCOMMODATION ? 'BOOKING.SUBMIT_BUTTON_ACCOMMODATION' : 'BOOKING.SUBMIT_BUTTON') | translate) }}
				</button>
			} @else {
				<button class="c-btn" (click)="next()" type="submit">{{ 'BOOKING.NEXT_BUTTON' | translate }}</button>
			}
		</div>
	</div>
}
